import { IApiPlayerExtended } from '@trackman/baseball-shared-components';
import { makeAutoObservable } from 'mobx';
import { BaseRunners } from 'models/baseRunners/BaseRunners';
import { Play } from 'models/tagging/Play';

export class ExtraInningRulesStore {
  isExtraRunnerEnabled = false;

  constructor() {
    makeAutoObservable(this);
  }

  setIsExtraRunnerEnabled = (value: boolean): void => {
    this.isExtraRunnerEnabled = value;
  };

  addExtraRunner = (lastPlay: Play): BaseRunners => {
    return {
      firstBase: null,
      secondBase: lastPlay.batter as unknown as IApiPlayerExtended,
      thirdBase: null,
    };
  };
}
